import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { EnquiryRequest } from '@core/models/enquiry.model';
import { EmptyApiResponse } from '@core/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  constructor(private readonly apiService: APIService) {

  }
  createEnquiry(requestLandingModel: EnquiryRequest) {
    return this.apiService.postWithAllResponse<EmptyApiResponse>('Enquiry/CreateEnquiry', requestLandingModel)
  }
}
